// src/AdminEventList.js
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";

function AdminEventList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "staffEvents"));
        const result = querySnapshot.docs.map(doc => ({
          name: doc.id,
          ...doc.data()
        }));
        setData(result);
      } catch (error) {
        console.error("イベントデータの取得に失敗しました:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        padding: "1rem", 
        fontFamily: "sans-serif",
        textAlign: "center",
        fontSize: "1.1rem",
        color: "#666"
      }}>
        データを読み込み中...
      </div>
    );
  }

  return (
    <div style={{ padding: "1rem", fontFamily: "sans-serif" }}>
      <h2>登録されたイベント一覧</h2>
      
      {data.length === 0 ? (
        <div style={{ 
          textAlign: "center", 
          padding: "2rem", 
          color: "#666",
          fontSize: "1.1rem"
        }}>
          登録されたイベントがありません。
        </div>
      ) : (
        data.map((staff, staffIndex) => (
          <div key={`staff_${staff.name}_${staffIndex}`} style={{ marginBottom: "2rem" }}>
            <h3 style={{ 
              borderBottom: "2px solid #007bff", 
              paddingBottom: "0.5rem",
              color: "#333"
            }}>
              {staff.name}
            </h3>
            
            {staff.events && staff.events.length > 0 ? (
              <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                {staff.events.map((e, index) => (
                  <li 
                    key={`event_${staff.name}_${index}_${e.date}_${e.title}`}
                    style={{
                      backgroundColor: "#f8f9fa",
                      border: "1px solid #dee2e6",
                      borderRadius: "6px",
                      padding: "1rem",
                      marginBottom: "0.75rem",
                      lineHeight: "1.6"
                    }}
                  >
                    <div style={{ marginBottom: "0.5rem" }}>
                      <strong>📅 {e.date}</strong> | <strong>📝 {e.title}</strong>
                    </div>
                    <div style={{ fontSize: "0.9rem", color: "#666" }}>
                      ⏰ 時間: {e.time || "未設定"} | 📍 場所: {e.location || "未設定"}
                    </div>
                    <div style={{ fontSize: "0.9rem", color: "#666" }}>
                      🔔 通知日: {e.notifyDate || "未設定"} | 🧳 持ち物: {e.items || "なし"}
                    </div>
                    {e.notes && (
                      <div style={{ 
                        marginTop: "0.5rem", 
                        fontSize: "0.9rem", 
                        fontStyle: "italic",
                        color: "#495057"
                      }}>
                        ✍️ 課題: {e.notes}
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <div style={{ 
                padding: "1rem", 
                color: "#666", 
                fontStyle: "italic",
                backgroundColor: "#f8f9fa",
                borderRadius: "4px"
              }}>
                このスタッフにはイベントが登録されていません。
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

export default AdminEventList;